import { Component, Input, OnInit } from '@angular/core';
import { RatingService } from '@arkius/shared-api';
import { UiRatingComponent } from '@components/ui/ui-rating/ui-rating.component';
import { ModalController } from '@ionic/angular';
import { take } from 'rxjs';
import { environment } from '@shared-envs';

@Component({
  selector: 'ark-lib-rate-modal',
  templateUrl: './rate-modal.component.html',
  styleUrls: ['./rate-modal.component.css'],
})
export class RateModalComponent implements OnInit {
  @Input() entityId!: number;
  @Input() entityType!: string;
  @Input() myRating?: number;

  stars = Array(5).fill(0); // 10 stars
  hoveredRating = 0;
  selectedRating = 0;

  constructor(
    private ratingService: RatingService,
    private modalCtrl: ModalController,
  ) {}

  ngOnInit() {
    if (this.myRating) {
      this.selectedRating = this.myRating;
    }
  }

  selectRating(rating: number) {
    this.selectedRating = rating;
  }

  submitRating() {
    // send `selectedRating` to backend or parent component
    environment.log('Submitted rating:', this.selectedRating);
    // dismiss modal or do whatever
    // const doubledRating = this.selectedRating * 2;

    this.ratingService
      .apiV5RatingPropositionIdPost(this.entityId, this.selectedRating)
      .pipe(take(1))
      .subscribe(() => {
        this.modalCtrl.dismiss({
          selectedRating: this.selectedRating,
        });
      });
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }
}
